import React from 'react'
import { Link } from 'react-router-dom'

import Card from '../../../components/layout/Card'
import type { Course } from '../../../../api/courses/types'
import ContentTag from '../../../components/content/ContentTag'
import { MetadataLabel } from '../../../components/content'
import * as dateLib from '../../../../libraries/date'
import Button from '../../../components/form/Button'
import { useI18N } from '../../../../libraries/i18n/hook'
import BookmarkButtonContainer from './BookmarkButton'
import CourseProgress from '../../../components/content/courses/CourseProgress'
import ShareButton from '../../../components/form/ShareButton'
import MoreActionsButton from '../../../components/form/MoreActionsButton'

type Props = { course: Course, nextVideoId?: number }
const CourseCoverCard: React.FC<Props> = ({ course, nextVideoId }) => {
  const { t } = useI18N()
  return (
    <Card fullHeight={false} className='bg-white shadow-sm'>
      <div className='relative flex flex-col p-2'>
        <div className='absolute end-2 top-2 inline-block'><ContentTag label={course.difficultyLevel.name} bgColor='deep-green' /></div>
        <img src={course.thumbnailsUrls.desktop} alt={course.title} className='w-full h-56 sm:h-56 rounded-s-lg sm:rounded-b-none sm:rounded-t-lg object-contain md:object-cover mx-auto' />
        <div className='flex items-center mt-4 justify-between w-full'>
          <ContentTag label={course.mainCategory.name} bgColor='soft-green' textColor='deep-green' />
          <div className='flex items-center gap-x-4 pl-4'>
            <div className='hidden sm:inline-block'><BookmarkButtonContainer bookmarked={course.userActivity?.saved} id={course.id} /></div>
            <div className='hidden sm:inline-block'><ShareButton title={course.title} /></div>
            <div className='ml-auto inline-block sm:hidden'>
              <MoreActionsButton
                items={[
                  { id: 'bookmark', item: <BookmarkButtonContainer bookmarked={course.userActivity?.saved} id={course.id}>{course.userActivity?.saved ? t('content.bookmarked.remove') : t('content.bookmarked.add')}</BookmarkButtonContainer> },
                  { id: 'share', item: <ShareButton title={course.title} size='md' /> }
                ]}
              />
            </div>
          </div>
        </div>
        <div className='relative flex flex-1 flex-row gap-x-4 items-center text-2xs md:text-xs'>
          <div className='min-w-[75px] md:min-w-[85px]'>{course.totalWatchTime && <MetadataLabel icon='clock'>{dateLib.parseSecondsToHoursAndMinutes(course.totalWatchTime)}</MetadataLabel>}</div>
          <CourseProgress completed={course.userActivity?.completed} totalWatchTime={course.totalWatchTime} totalPlayTime={course.userActivity?.totalPlayTime} />
        </div>
        {nextVideoId && (
          <Link to={`/courses/${course.id}/videos/${nextVideoId}`}>
            <Button variant='primary' size='sm' className='w-full my-2'>
              {course.userActivity?.totalPlayTime ?? 0 > 0 ? t('course.continue') : t('course.start')}
            </Button>
          </Link>
        )}
      </div>
    </Card>
  )
}

export default CourseCoverCard
